import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { Button } from "react-bootstrap";
import Header from "../../layout/Header";
import { Loader } from "../../loader";
import CustomModal from "../../modal";
import { genuityCheckData, login, scanData } from "../../auth/redux/store";
import { isOtpVerified, setOtpVerified } from "../../../utils/otpSession";
import { loginPath, resolveLang } from "../../../utils/navigation";
import {
  buildFcGenuityPayload,
  isFcAutoVerifyEligible,
  getUfromFcRaw,
  parseUfromFcParam,
  persistFcSession,
} from "../../../utils/fcDeepLink";
import { submitGenuityCheck } from "../../../utils/genuitySubmit";
import {
  getScanLimitNotice,
  isScanLimitReached,
} from "../../../utils/genuityCheck";
import Check from "../../../assets/images/check.png";
import ProductId from "../../../assets/images/productId.png";
import Not_Genuine from "../../../assets/images/not_genuine.png";
import Wrongotp from "../../../assets/images/wrongotp.png";

import ReactGA from "react-ga4";

const FromFcEntry = () => {
  const { lang } = useParams();
  const resolvedLang = resolveLang(lang);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [scanResponseData, setScanResponseData] = useState({});
  const [scanErrorResponseData, setScanErrorResponseData] = useState({});
  const [genunityCheckModal, setGenunityCheckModal] = useState(false);
  const [errorModalGenunity, setErrorModalGenunity] = useState(false);
  const [productID, setProductID] = useState("");
  const [homeIconVisible, setHomeIconVisible] = useState(() => isOtpVerified());

  // const scanLimitReached = isScanLimitReached(scanResponseData); 
  const scanLimitReached = scanResponseData?.maxAcresReached; 
  const scanLimitNotice = getScanLimitNotice(scanResponseData) || scanResponseData.uq_message || t("genuityCheck.scanLimitFallback");

  // alert(JSON.stringify(scanLimitNotice));


  const handleGenuityScanMore = () => {
    setGenunityCheckModal(false);
    navigate(`/${resolvedLang}/scanProduct`);
  };

  const handleGenuityProceedCashback = () => {
    if (scanLimitReached) return;
    setGenunityCheckModal(false);
    // navigate(`/${resolvedLang}/rewardjourney`);

    if(scanResponseData?.isGiftClaimed) {
      navigate(`/${lang}/giftClaim`);
      return;
    }

    if (scanResponseData.isSpinDone) {
      navigate(`/${lang}/spinNotApplicable`);
    } else {
      navigate(`/${lang}/spinwheel`);
    }
  };

  const routeAfterSuccess = (jsonReposneData) => { 

    if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) {
      setErrorModalGenunity(true);
      return;
    }

    if (jsonReposneData.isAlreadyScannedProduct) {
      setErrorModalGenunity(true);
      return;
    } 

    // if (jsonReposneData.isSpinDone === true && jsonReposneData.isAlreadyScannedProduct) { 
    //   setErrorModalGenunity(true);
    //   return;
    // }

    if (
      !jsonReposneData.soyabeanAcres ||
      jsonReposneData.soyabeanAcres == 0 ||
      jsonReposneData.soyabeanAcres === null ||
      jsonReposneData.soyabeanAcres === undefined
    ) {
      navigate(`/${resolvedLang}/register`);
      return;
    }

    setGenunityCheckModal(true);
  };

  // useEffect(() => {
  //   let cancelled = false;

  //   const finishLoading = () => {
  //     if (!cancelled) setLoading(false);
  //   };

  //   const run = async () => {
  //     setLoading(true);
  //     setErrorMsg("");

  //     const { raw, isFreshLink } = getUfromFcRaw(searchParams);

  //     if (!raw) {
  //       setErrorMsg(t("sessionExperied", { defaultValue: "Invalid or expired link." }));
  //       finishLoading();
  //       return;
  //     }

  //     sessionStorage.setItem("ufromFcPayload", raw);
  //     const fcData = parseUfromFcParam(raw);

  //     if (!fcData) {
  //       setErrorMsg(
  //         t("Something_went_wrong", {
  //           defaultValue: "Could not read link data. Please scan the QR again.",
  //         })
  //       );
  //       finishLoading();
  //       return;
  //     }

  //     persistFcSession(fcData, { isFreshLink });
  //     const payload = buildFcGenuityPayload(fcData, i18n.language);

  //     if (!isFcAutoVerifyEligible(fcData)) {
  //       dispatch(scanData(JSON.stringify({ ...payload, otpVerified: false })));
  //       dispatch(
  //         login({
  //           statusCode: "200",
  //           mobileNumber: payload.mobileNumber,
  //           customerId: payload.customerId,
  //         })
  //       );
  //       setOtpVerified(false);
  //       setHomeIconVisible(false);
  //       finishLoading();
  //       if (!cancelled) {
  //         navigate(`/${resolvedLang}/verifyOtp`, { replace: true });
  //       }
  //       return;
  //     }

  //     dispatch(
  //       scanData(
  //         JSON.stringify({
  //           ...payload,
  //           otpVerified: true,
  //         })
  //       )
  //     );

  //     dispatch(
  //       login({
  //         statusCode: "200",
  //         mobileNumber: payload.mobileNumber,
  //         customerId: payload.customerId,
  //       })
  //     );

  //     setOtpVerified(true);
  //     setHomeIconVisible(true);

  //     ReactGA.event({
  //       category: "FC Deep Link",
  //       action: "AUTO_GENUINITY_CHECK",
  //     });
  //     debugger;
  //     try {
  //       const jsonReposneData = await submitGenuityCheck(payload, {
  //         appLangCode: i18n.language,
  //         customerId: payload.customerId,
  //         mobileNumber: payload.mobileNumber,
  //       });

  //       if (cancelled) return;

  //       console.log(JSON.stringify(payload) + "payload");
  //       console.log((JSON.stringify(scanResponseData)) + "scanResponseData MOBILE");


  //       if (
  //         jsonReposneData?.statusCode === "200" &&
  //         jsonReposneData?.uq_responseCode === "100"
  //       ) {
  //         if (jsonReposneData.strongArmObject?.textTwo) {
  //           setProductID(jsonReposneData.strongArmObject.textTwo);
  //         }
  //         setScanResponseData(jsonReposneData);
  //         dispatch(genuityCheckData(jsonReposneData));
  //         if (jsonReposneData.customerId) {
  //           sessionStorage.setItem("cid", String(jsonReposneData.customerId));
  //         }
  //         routeAfterSuccess(jsonReposneData);
  //         finishLoading();
  //         return;
  //       }

  //       if (
  //         jsonReposneData?.statusCode === "200" &&
  //         jsonReposneData?.uq_responseCode != "100"
  //       ) {
  //         setScanResponseData(jsonReposneData);
  //         setErrorModalGenunity(true);
  //         finishLoading();
  //         return;
  //       }

  //       setErrorMsg(
  //         jsonReposneData?.message ||
  //         t("Something_went_wrong", { defaultValue: "Something went wrong." })
  //       );
  //       finishLoading();
  //     } catch (err) {
  //       console.error("FC auto genuinity check failed:", err);
  //       if (!cancelled) {
  //         setErrorMsg(
  //           t("Something_went_wrong", { defaultValue: "Something went wrong." })
  //         );
  //         finishLoading();
  //       }
  //     }
  //   };

  //   run();

  //   return () => {
  //     cancelled = true;
  //   };
  // }, [
  //   dispatch,
  //   i18n.language,
  //   navigate,
  //   resolvedLang,
  //   searchParams,
  //   t,
  // ]);



  const hasCalled = useRef(false);

  useEffect(() => {
    // Prevent double execution
    if (hasCalled.current) return;

    hasCalled.current = true;

    let cancelled = false;

    const finishLoading = () => {
      if (!cancelled) {
        setLoading(false);
      }
    };

    const run = async () => {
      try {
        setLoading(true);
        setErrorMsg("");

        const { raw, isFreshLink } = getUfromFcRaw(searchParams);

        // Invalid link
        if (!raw) {
          setErrorMsg(
            t("sessionExperied", {
              defaultValue: "Invalid or expired link.",
            })
          );
          finishLoading();
          return;
        }

        sessionStorage.setItem("ufromFcPayload", raw);

        const fcData = parseUfromFcParam(raw);

        // Invalid parsed data
        if (!fcData) {
          setErrorMsg(
            t("Something_went_wrong", {
              defaultValue:
                "Could not read link data. Please scan the QR again.",
            })
          );

          finishLoading();
          return;
        }

        persistFcSession(fcData, { isFreshLink });

        const payload = buildFcGenuityPayload(
          fcData,
          i18n.language
        );

        // OTP NOT VERIFIED
        if (!isFcAutoVerifyEligible(fcData)) {
          dispatch(
            scanData(
              JSON.stringify({
                ...payload,
                otpVerified: false,
              })
            )
          );

          dispatch(
            login({
              statusCode: "200",
              mobileNumber: payload.mobileNumber,
              customerId: payload.customerId,
            })
          );

          setOtpVerified(false);
          setHomeIconVisible(false);

          finishLoading();

          if (!cancelled) {
            navigate(`/${resolvedLang}/verifyOtp`, {
              replace: true,
            });
          }

          return;
        }

        // OTP VERIFIED
        dispatch(
          scanData(
            JSON.stringify({
              ...payload,
              otpVerified: true,
            })
          )
        );

        dispatch(
          login({
            statusCode: "200",
            mobileNumber: payload.mobileNumber,
            customerId: payload.customerId,
          })
        );

        setOtpVerified(true);
        setHomeIconVisible(true);

        ReactGA.event({
          category: "FC Deep Link",
          action: "AUTO_GENUINITY_CHECK",
        });

        // API CALL
        const jsonReposneData = await submitGenuityCheck(
          payload,
          {
            appLangCode: i18n.language,
            customerId: payload.customerId,
            mobileNumber: payload.mobileNumber,
          }
        );

        if (cancelled) return;

        console.log("payload", payload);
        console.log("response", jsonReposneData);

        // SUCCESS
        if (
          jsonReposneData?.statusCode === "200" &&
          jsonReposneData?.uq_responseCode === "100"
        ) {
          if (jsonReposneData?.strongArmObject?.textTwo) {
            setProductID(
              jsonReposneData.strongArmObject.textTwo
            );
          }

          setScanResponseData(jsonReposneData);

          dispatch(genuityCheckData(jsonReposneData));

          if (jsonReposneData?.customerId) {
            sessionStorage.setItem(
              "cid",
              String(jsonReposneData.customerId)
            );
          }

          routeAfterSuccess(jsonReposneData);

          finishLoading();
          return;
        }

        // FAILED RESPONSE
        if (
          jsonReposneData?.statusCode === "200" &&
          jsonReposneData?.uq_responseCode !== "100"
        ) {
          setScanResponseData(jsonReposneData);
          setErrorModalGenunity(true);

          finishLoading();
          return;
        }

        // GENERAL ERROR
        setErrorMsg(
          jsonReposneData?.message ||
          t("Something_went_wrong", {
            defaultValue: "Something went wrong.",
          })
        );

        finishLoading();
      } catch (err) {
        console.error(
          "FC auto genuinity check failed:",
          err
        );

        if (!cancelled) {
          setErrorMsg(
            t("Something_went_wrong", {
              defaultValue: "Something went wrong.",
            })
          );

          finishLoading();
        }
      }
    };

    run();

    return () => {
      cancelled = true;
    };
  }, []);

  return (
    <>
      <Header hideHomeIcon={!homeIconVisible} />
      <div className="main px-2 mt-3">
        {loading && <Loader />}
        {!loading && errorMsg && (
          <div className="container p-4 text-center">
            <p className="text-danger">{errorMsg}</p>
            <Button
              className="btn btn-secondary mt-3"
              onClick={() => navigate(loginPath(resolvedLang))}
            >
              {t("login", { defaultValue: "Login" })}
            </Button>
          </div>
        )}
      </div>

      <CustomModal
        id="genuinityCheckModalFc"
        title=""
        content={
          <div className="d-flex flex-column align-items-center" style={{ gap: "1rem" }}>
            <img src={Check} alt="" />
            {scanResponseData.productImageUrl && (
              <img
                src={scanResponseData.productImageUrl}
                alt=""
                style={{ width: "125px" }}
              />
            )}
            {scanResponseData.primaryRewardMsg && (
              <p
                className="text-secondaryColor font-bold mb-0"
                dangerouslySetInnerHTML={{
                  __html: scanResponseData.primaryRewardMsg,
                }}
              />
            )}
            {scanResponseData.secondaryRewardMsg && (
              <p
                className="mb-0 text-sm"
                dangerouslySetInnerHTML={{
                  __html: scanResponseData.secondaryRewardMsg,
                }}
              />
            )}
            {scanLimitReached && (
              <p
                className="genuityCheckLimitMsg text-center text-danger mb-0 px-2"
                dangerouslySetInnerHTML={{
                  __html: scanLimitNotice.replace(/\r\n|\n|\r/g, "<br />"),
                }}
              />
            )}
            {productID && (
              <div className="text-left mb-2 w-100">
                <p className="mb-1">{t("Product_Serial_Number")}</p>
                <p className="mb-0" style={{ fontWeight: "600" }}>
                  <img
                    src={ProductId}
                    alt=""
                    className="img-fluid mr-2"
                    style={{ width: "35px" }}
                  />
                  {productID}
                </p>
              </div>
            )}
          </div>
        }
        footer={
          <div className="genuityCheckModalFooter w-100">
            {/* <Button
              className="w-100 rounded-4 py-2 btn-secondary"
              onClick={handleGenuityScanMore}
            >
              {t("Scanmore")}
            </Button> */}
            {!scanLimitReached && (
              <Button
                className="w-100 rounded-4 py-2 btn-secondary"
                onClick={handleGenuityProceedCashback}
              >
                {t("genuityCheck.proceedToCashback")}
              </Button>
            )}
          </div>
        }
        show={genunityCheckModal}
        onHide={() => setGenunityCheckModal(false)}
      />

      <CustomModal
        id="genuinityCheckModalErrorFc"
        // title={t("genuityCheck")}
        content={
          <>
            {/* <img src={Not_Genuine} alt="" className="img-fluid my-4" />
            <p
              className="modalInfo"
              dangerouslySetInnerHTML={{
                __html:
                  scanErrorResponseData?.primaryRewardMsg ||
                  scanErrorResponseData?.message ||
                  "",
              }}
            /> */}

            <img src={Wrongotp} alt='Wrongotp' className='img-fluid my-4' />

            {scanResponseData.primaryRewardMsg && (
              <p style={{ fontWeight: '600', color: '#000000', textAlign: 'center' }}>
                {scanResponseData?.primaryRewardMsg}
              </p>
            )}
            {scanResponseData.secondaryRewardMsg && (
              <p style={{ fontWeight: '400', color: '#000000', textAlign: 'center' }} >
                {scanResponseData?.secondaryRewardMsg}
              </p>
            )}



          </>
        }
        footer={
          // <Button
          //   className="w-100 rounded-4 py-2 btn-secondary"
          //   onClick={handleGenuityScanMore}
          // >
          //   {t("Scanmore")}
          // </Button>

          <Button
            className="w-100 rounded-4 py-2  btn-primary" onClick={() => {
              ReactGA.event({
                category: 'User Scan More',
                action: 'Clicked the Scan More Button',
              });
              navigate(`/${lang}/scanProduct`)
            }}>
            {t("rescan")}
            {/* दोबारा स्कैन करें */}
          </Button>
        }
        show={errorModalGenunity}
        onHide={() => setErrorModalGenunity(false)}
      />
    </>
  );
};

export default FromFcEntry;
